<ng-container *ngIf="isEdit"> <flx-user-card-edit [user]="selected_user"></flx-user-card-edit> </ng-container>

<!-- (returnToUserViewEvent)="setToView()"-->
